import React from "react";

export const Table = React.forwardRef(function Table(
  { className = "", style = {}, ...props },
  ref
) {
  return (
    <div
      className={`tw-w-full tw-overflow-auto tw-border-collapse ${className}`}
    >
      <table
        ref={ref}
        className="tw-w-full tw-caption-bottom tw-text-sm tw-border-collapse"
        style={{
          borderSpacing: 0,
          tableLayout: style.tableLayout || "auto",
          ...style,
        }}
        {...props}
      />
    </div>
  );
});

export const TableHeader = React.forwardRef(function TableHeader(
  { className = "", ...props },
  ref
) {
  return (
    <thead ref={ref} className={`[&_tr]:tw-border-b ${className}`} {...props} />
  );
});

export const TableBody = React.forwardRef(function TableBody(
  { className = "", ...props },
  ref
) {
  return (
    <tbody
      ref={ref}
      className={`tw-[&_tr:last-child]:tw-border-0 ${className}`}
      {...props}
    />
  );
});

export const TableFooter = React.forwardRef(function TableFooter(
  { className = "", ...props },
  ref
) {
  return (
    <tfoot
      ref={ref}
      className={`tw-bg-gray-50 tw-font-medium tw-text-gray-900 ${className}`}
      {...props}
    />
  );
});

export const TableRow = React.forwardRef(function TableRow(
  { className = "", ...props },
  ref
) {
  return (
    <tr
      ref={ref}
      className={`tw-transition-colors tw-duration-150 hover:tw-bg-gray-50 tw-border-0 ${className}`}
      {...props}
    />
  );
});

export const TableHead = React.forwardRef(function TableHead(
  { className = "", style, ...props },
  ref
) {
  return (
    <th
      ref={ref}
      style={{
        position: "relative",
        userSelect: "none",
        borderRight: "1px solid #e5e7eb",
        borderBottom: "1px solid #e5e7eb",
        backgroundColor: "#f9fafb",
        height: "44px",
        ...style,
      }}
      className={`tw-text-left tw-align-middle tw-font-medium tw-text-gray-700 tw-text-sm ${className}`}
      {...props}
    />
  );
});

export const TableCell = React.forwardRef(function TableCell(
  { className = "", style = {}, ...props },
  ref
) {
  return (
    <td
      ref={ref}
      style={{
        borderRight: "1px solid #f3f4f6",
        borderBottom: "1px solid #f3f4f6",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        height: "48px",
        ...style,
      }}
      className={`tw-p-2 tw-align-middle tw-text-gray-900 tw-text-sm ${className}`}
      {...props}
    />
  );
});

export const TableCaption = React.forwardRef(function TableCaption(
  { className = "", ...props },
  ref
) {
  return (
    <caption
      ref={ref}
      className={`tw-mt-4 tw-text-sm ${className}`}
      {...props}
    />
  );
});
